import React from "react";

const MAX_LISTED = 20;

/**
 * Names the Statement of Applicability controls that still have no Applicable / Not applicable
 * decision. Control implementation sync and the Training stage stay blocked until none remain
 * (server: SOA_APPLICABILITY_UNSET). Plain markup (no antd) so any stage panel can embed it.
 * Renders nothing when every row is decided.
 */
export function SoaUnsetNotice({ controls }) {
  const list = Array.isArray(controls) ? controls.filter(Boolean) : [];
  if (list.length === 0) return null;
  const shown = list.slice(0, MAX_LISTED);
  return (
    <div
      role="alert"
      data-testid="soa-unset-notice"
      className="rounded-xl border border-[color:var(--color-warn-line)] bg-[color:var(--color-warn-bg)] px-4 py-3 text-xs text-[color:var(--color-warn-fg)]"
    >
      <div className="font-bold">
        {list.length} Statement of Applicability control{list.length === 1 ? " has" : "s have"} no applicability decision.
      </div>
      <p className="mt-1">
        Set each one to Applicable or Not applicable. Syncing control implementation and opening Training stay blocked until every
        control is decided.
      </p>
      <p data-testid="soa-unset-controls" className="mt-1 font-semibold">
        {shown.join(", ")}
        {list.length > shown.length ? ` (+${list.length - shown.length} more)` : ""}
      </p>
    </div>
  );
}

/** Small state badge for one SoA row: Applicable / Not applicable / Unset. */
export function SoaApplicabilityBadge({ value }) {
  const v = String(value ?? "").toUpperCase();
  const [label, cls] =
    v === "Y"
      ? ["Applicable", "bg-[color:var(--color-ok-bg)] text-[color:var(--color-ok-fg)] border-[color:var(--color-ok-line)]"]
      : v === "N"
        ? ["Not applicable", "bg-[color:var(--color-bg-alt)] text-[color:var(--color-text-muted)] border-[color:var(--color-border)]"]
        : ["Unset", "bg-[color:var(--color-warn-bg)] text-[color:var(--color-warn-fg)] border-[color:var(--color-warn-line)]"];
  return (
    <span data-testid="soa-applicability-badge" data-state={v === "Y" || v === "N" ? v : "UNSET"} className={`inline-block rounded border px-1.5 py-0.5 text-[10px] font-bold uppercase ${cls}`}>
      {label}
    </span>
  );
}

export default SoaUnsetNotice;
